{
  "client": "Client",
  "production": "Production",
  "agency": "Agency",
  "deadline": "Deadline",
  "project_deadline": "Project deadline",
  "current_task": "Current Task",
  "project_progress": "Project Progress",
  "Task": "Task",
  "review_now": "Go to step",
  "task_completed": "task(s) completed",
  "development_progress": "Development Progress:",
  "project_finished": "Project is finished",
  "deadline_step": "Step deadline",

  "1_development": "1. Development",
  "2_pre_production": "2. Pre-Production",
  "3_production": "3. Production",
  "4_post_production": "4. Post-Production",
  "5_delivery": "5. Delivery",

  "idea": "Idea",
  "brief": "Brief",
  "budget": "Budget",
  "storyboard": "Storyboard",
  "quote": "Quote",
  "first_payment": "First payment",
  "ppm": "PPM",
  "motion_design": "Motion design",
  "first_correction": "First correction",
  "second_correction": "Second correction",
  "cast_preselection": "Cast preselection",
  "shooting_days": "Shooting days",
  "preselection": "Preselection",
  "second_payment": "Second payment",
  "locations": "Locations",
  "contact": "Contact",
  "picture_lock": "Picture lock",
  "final_sound": "Final sound",
  "color_grading": "Color grading",
  "final_film": "Final film",
  "final_payment": "Final payment",
  "rights_ownership": "Rights ownership",
  "debriefing": "Debriefing",
  "final_sound_mix": "Final sound mix",
  "return_gear": "Return gear",
  "editing": "Editing",
  "prepare_edit": "Prepare edit",
  "first_rough_cut": "First rough cut",
  "1st_payment": "1st Payment",
  "line_producers": "Line producers",
  "rushes_archives": "Rushes archives",

  "add_file": "Add file",
  "add_director": "Add director",
  "add_producer": "Add producer",
  "add_line_producer": "Add line producer",
  "add_moodboard": "Add moodboard",
  "add_shot": "Add shot",
  "add_contract": "Add contract",
  "add_invoice": "Add invoice",
  "add_note": "Add note",
  "add_comment": "Add comment",
  "add_talent": "Add talent",
  "add_location": "Add location",
  "add_shooting_day": "Add shooting day",
  "add_gear": "Add gear",
  "add_scene": "Add scene",
  "add_team": "Add team",
  "add_rush": "Add rush",
  "add_new_folder": "Add new folder",
  "add_video": "Add video",
  "add_folder": "Add folder",
  "add_character": "Add character",

  "update_character": "Update character",

  "files": "Files",
  "accepted": "Accepted File Types",
  "drag": "Drag and Drop here",
  "or": "or",
  "browse_files": "Browse Files",

  "requirements": "Requirements",
  "nearest_parking": "Nearest parking",
  "nearest_hospital": "Nearest hospital",
  "shot_list": "Shot list",

  "note": "Note",
  "table": "Table",
  "equipment": "Equipment",
  "qty": "qty",
  "rate_day": "rate/day",
  "rate_week": "rate/week",
  "rent_period": "rent period",
  "subtotal": "subtotal",
  "pick_up": "pick up",

  "generate_callsheet": "Generate callsheet",
  "directors_note": "Director's note",
  "rushes": "Rushes",
  "work_in_progress": "Edit in progress",
  "come_back": "Please, come back in few days",
  "selected": "selected",
  "on": "on",
  "start_video_call": "start video call",
  "video": "Video",
  "rushes_list": "Rushes list",
  "unsupported": "unsupported preview file type",
  "upload_file": "Upload file",
  "all_scenes": "All scenes",
  "all": "All",
  "all_files": "All files",
  "no_cover": "No cover pictures",
  "overview": "Project overview",
  "language": "en",
  "will_removed": "Project will be removed on:",
  "share_project": "Share project",
  "uploaded_by": "Uploaded by: {{by}}",

  "delete_scene": "Are you sure you want to delete this scene ?",
  "delete_project": "Are you sure you want to delete this project ?",
  "delete_location": "Delete location",
  "delete_file": "Delete file",
  "delete_step": "Delete step",

  "script_one": "Script",
  "script_other": "Scripts",
  "scriptWithCount_one": "{{count}} script",
  "scriptWithCount_other": "{{count}} scripts",

  "callsheet_one": "Callsheet",
  "callsheet_other": "Callsheets",
  "callsheetWithCount_one": "{{count}} callsheet",
  "callsheetWithCount_other": "{{count}} callsheet",

  "document_one": "document",
  "document_other": "documents",
  "documentWithCount_one": "{{count}} document",
  "documentWithCount_other": "{{count}} documents",

  "comment_one": "Comment",
  "comment_other": "Comments",
  "commentWithCount_one": "{{count}} Comment",
  "commentWithCount_other": "{{count}} Comments",

  "contract_one": "Contract",
  "contract_other": "Contracts",
  "contractWithCount_one": "{{count}} Contract",
  "contractWithCount_other": "{{count}} Contracts",

  "gear_one": "Gear",
  "gear_other": "Gears",
  "gearWithCount_one": "{{count}} Gear",
  "gearWithCount_other": "{{count}} Gears",

  "shot_one": "Shot",
  "shot_other": "Shots",
  "shotWithCount_one": "{{count}} Shot",
  "shotWithCount_other": "{{count}} Shots",

  "rush_one": "Rush",
  "rush_other": "Rushes",
  "rushWithCount_one": "{{count}} Rush",
  "rushWithCount_other": "{{count}} Rushes",

  "scene_one": "Scene",
  "scene_other": "Scene",
  "sceneWithCount_one": "{{count}} Scene",
  "sceneWithCount_other": "{{count}} Scenes",

  "character_one": "Character",
  "character_other": "Characters",
  "characterWithCount_one": "{{count}} Character",
  "characterWithCount_other": "{{count}} Characters",

  "producer": "Producer",
  "producer_plural": "Producers",
  "producer_with_count": "{{count}} Producer",
  "producer_plural_with_count": "{{count}} Producers",

  "director": "Director",
  "director_plural": "Directors",
  "director_with_count": "{{count}} Director",
  "director_plural_with_count": "{{count}} Directors",

  "moodboard": "Moodboard",
  "moodboard_plural": "moodboards",
  "moodboard_with_count": "{{count}} Moodboard",
  "moodboard_plural_with_count": "{{count}} moodboards",

  "invoice": "Invoice",
  "invoice_plural": "Invoices",
  "invoice_with_count": "{{count}} Invoice",
  "invoice_plural_with_count": "{{count}} Invoices",

  "line_producer": "Line producer",
  "line_producer_plural": "Line producers",
  "line_producer_with_count": "{{count}} Line producer",
  "line_producer_plural_with_count": "{{count}} Line producers",

  "crew": "Crew",
  "crew_plural": "Crews",
  "crew_with_count": "{{count}} Crew",
  "crew_plural_with_count": "{{count}} Crews",

  "role_one": "Role",
  "role_other": "Roles",
  "roleWithCount_one": "{{count}} Role",
  "roleWithCount_other": "{{count}} Roles",

  "people_one": "person",
  "people_other": "people",
  "peopleWithCount_one": "{{count}} person",
  "peopleWithCount_other": "{{count}} people",

  "location_one": "Location",
  "location_other": "Locations",
  "locationWithCount_one": "{{count}} Location",
  "locationWithCount_other": "{{count}} Locations",

  "shooting_day_one": "Shooting day",
  "shooting_day_other": "Shooting days",
  "shooting_dayWithCount_one": "{{count}} Shooting day",
  "shooting_dayWithCount_other": "{{count}} Shooting days",

  "invoice_second_payment_one": "Invoice",
  "invoice_second_payment_other": "Invoices",
  "invoice_second_paymentWithCount_one": "{{count}} Invoice",
  "invoice_second_paymentWithCount_other": "{{count}} Invoices",

  "invoice_final_payment_one": "Invoice",
  "invoice_final_payment_other": "Invoices",
  "invoice_final_paymentWithCount_one": "{{count}} Invoice",
  "invoice_final_paymentWithCount_other": "{{count}} Invoices",

  "download": "Download",
  "downloads_one": "Download",
  "download_other": "Downloads",
  "downloadWithCount_one": "{{count}} Download",
  "downloadWithCount_other": "{{count}} Downloads",

  "error_project": "An error has occurred while displaying this file preview",
  "error_comment": "An error has occurred while displaying the comments",
  "error_moodboard": "An error has occurred while displaying the moodboard",
  "error_file": "An error has occurred while displaying the file",
  "error_add_contract": "An error has occurred while displaying add contract component",
  "error_waiting": "An error has occurred while displaying waiting component",
  "error_location": "An error has occurred while displaying location",
  "error_screen": "An error has occurred while displaying the step page",
  "error_toolbar": "An error has occurred while displaying the toolbar",
  "error_talent": "An error has occurred while displaying this talent",
  "error_video_player": "An error has occurred while displaying the video player",
  "error_video_add_comment": "An error has occurred while displaying add comment component",
  "error_video_comments": "An error has occurred while displaying the comments"
}
